<template>
  <article>
    <section id="contact-one">
      <div class="wrapper">
        <div class="subhead">
          <span>总部地址</span>
        </div>
        <!-- <div style="margin-bottom:20px">
          <div class="pure-u-1-2 pure-u-xl-1-3" v-for="(item, index) in getCompanyAddress" :key="index">
            <div class="p5-box">
              <div class="products-item">
                <div class="products-from" v-html="item.content"></div>
              </div>
            </div>
          </div>
        </div> -->
        <!-- 总部地址 -->
        <section id="top-contact" class="lxwm" style="margin-top: 20px;margin-bottom: 20px;">
          <div class="wrapper">
            <div class="pure-g">
              <div class="pure-u-1 pure-u-xl-1-2">
                <div class="p1-box">
                  <!-- <img src="../assets/map.jpg" class="pure-img"> -->
                  <div id="container" style="height: 400px;"></div>
                </div>
              </div>
              <div class="pure-u-1 pure-u-xl-1-2 m-addr-phone">
                <div class="p1-box">
                  <div class="lxwm-info">
                    <div class="email-tel" style="margin-top: 30px;">
                      <div class="">
                        <img style="width:auto;margin-top: 4px;" src="../assets/contact/message.png">
                      </div>
                      <p style="height: 35px;margin: 0 0 0 10px;">风口赛道，刚需产品，面向全国招募合伙人</p>
                    </div>
                    <div class="addr" style="margin-top: 50px;">
                      <div class="">
                        <img style="width:auto;margin-top: 4px;" src="../assets/contact/company.png">
                      </div>
                      <p style="height: 35px;margin:  0 0 0 10px;">河南嗨浪技术有限公司</p>
                    </div>
                    <div class="addr" style="margin-top: 50px;">
                      <div class="">
                        <img style="width: auto;" src="../assets/contact/address.png">
                      </div>
                      <p style="height: 35px;margin:  0 0 0 10px;">河南自贸试验区郑州片区（郑东）商鼎路东风南路升龙广场3号楼A座</p>
                    </div>
                    <div class="email-tel" style="margin-top: 50px;">
                      <div class="">
                        <img style="width:auto;margin-top: 4px;" src="../assets/contact/about.png">
                      </div>
                      <p style="height: 35px;margin: 0 0 0 10px;">4000-8000-11</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- 总部地址 end -->
      </div>
    </section>
  </article>
</template>

<script>
export default {
  name: "Contact",
  data() {
    return {
      getCompanyAddress: []
    }
  },
  mounted() {
    // 公司地址
    this.companyAddress()
    // 地图
    this.initMap()
  },
  methods: {
    // 公司地址
    companyAddress() {
      this.$http.get("/website/hnWebsiteContentInfo/getList", {
        firstType: "6"
      }, res => {
        if (res.code == '200') {
          this.getCompanyAddress = res.data.公司地址[3]
        }
      })
    },
    // 地图
    initMap() {
      var center = new TMap.LatLng(34.756401, 113.770304)
      var map = new TMap.Map('container', {
        zoom: 17, // 设置地图缩放
        center: center, // 设置地图中心点坐标，
        pitch: 0, // 俯仰度
        rotation: 0, // 旋转角度
      });
      var marker = new TMap.MultiMarker({
        map: map,
        styles: {
          marker: new TMap.MarkerStyle({
            width: 20, // 样式宽
            height: 30, // 样式高
            anchor: { x: 10, y: 30 }, // 描点位置
          }),
        },
        geometries: [
          {
            // 标记位置(纬度，经度，高度)
            position: center,
            id: 'marker',
          },
        ],
      })
    },
  }
}
</script>

<style scoped>
@import "~@/assets/styles/contact.css";
</style>
